import { useLayout } from "../contexts/layoutContext";
import MobileTabBar from "../components/MobileTabBar";

const SIDEBAR_WIDTH_EXPANDED = "14rem";
const SIDEBAR_WIDTH_COLLAPSED = "4rem";
const TAB_BAR_PADDING = "calc(3.75rem + env(safe-area-inset-bottom, 0px))";

export const MainContent = ({ children }) => {
  const { isDesktop, sidebarCollapsed, showTabBar } = useLayout();

  const marginLeft = !isDesktop
    ? "0"
    : sidebarCollapsed
      ? SIDEBAR_WIDTH_COLLAPSED
      : SIDEBAR_WIDTH_EXPANDED;

  return (
    <div
      className="flex flex-1 flex-col min-h-screen min-w-0 bg-gray-50 transition-[margin-left] duration-200 ease-out"
      style={{
        marginLeft,
        paddingBottom: showTabBar ? TAB_BAR_PADDING : undefined,
      }}
    >
      {children}
      <MobileTabBar />
    </div>
  );
};
